import React from "react";
import { motion } from "framer-motion";
import { Reveal, Overline } from "../components/site/Reveal";
import { APPROACH } from "../data/content";

export const Approach = () => (
  <section id="approach" className="relative bg-bg-light py-24 sm:py-32" data-testid="approach-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><Overline>Our Approach</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            A five-stage <span className="text-gradient-gold">transformation pathway</span>.
          </h2>
        </Reveal>
      </div>

      <div className="relative mt-20">
        <div className="absolute left-0 right-0 top-8 hidden h-px bg-black/10 lg:block" />
        <motion.div
          className="absolute left-0 top-8 hidden h-px origin-left bg-gradient-to-r from-emerald-base via-emerald-light to-gold lg:block"
          initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }}
          transition={{ duration: 2.4, ease: "easeInOut" }}
        />
        <div className="grid gap-10 lg:grid-cols-5">
          {APPROACH.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.12}>
              <div className="relative" data-testid={`approach-step-${i}`}>
                <div className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full border border-gold/40 bg-white font-serif text-2xl text-gradient-gold shadow-[0_6px_20px_rgba(3,31,20,0.06)]">
                  {s.no}
                </div>
                <h3 className="mt-6 font-serif text-2xl text-charcoal">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
